import { useStyles } from "./AppHeader.styles";
import { NewLogoImage } from "assets/images/common";
import {
  Burger,
  Center,
  Container,
  Group,
  Header,
  Menu,
  Paper,
  Transition,
  UnstyledButton,
} from "@mantine/core";
import { useToggle } from "@mantine/hooks";
import { Link, useNavigate } from "react-router-dom";
import { IconChevronDown } from "@tabler/icons";

export const AppHeader = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [opened, toggleOpened] = useToggle([false, true]);

  const links: {
    link: string;
    label: string;
    links?: { link: string; label: string }[];
  }[] = [
    { label: "Home", link: "/" },
    {
      label: "Rating Instruments",
      link: "/rating-instruments",
      links: [{ label: "OSCE", link: "/rating-instruments/osce" }],
    },
    { label: "Evaluation of Rating Instruments", link: "/feedback" },
  ];

  const items = links.map((link) => {
    const menuItems = link.links?.map((item) => (
      <Menu.Item key={item.link} component={Link} to={item.link}>
        {item.label}
      </Menu.Item>
    ));

    if (menuItems) {
      return (
        <Menu
          key={link.label}
          trigger="hover"
          transitionDuration={0}
          position="bottom-end"
          offset={1}
          width={160}
          shadow="md"
        >
          <Menu.Target>
            <a
              href={link.link}
              className={classes.link}
              onClick={(event) => event.preventDefault()}
            >
              <Center>
                <span className={classes.linkLabel}>{link.label}</span>
                <IconChevronDown size={12} />
              </Center>
            </a>
          </Menu.Target>
          <Menu.Dropdown>{menuItems}</Menu.Dropdown>
        </Menu>
      );
    }
    return (
      <UnstyledButton
        key={link.label}
        className={classes.link}
        onClick={() => {
          navigate(link.link);
        }}
      >
        <Center>{link.label}</Center>
      </UnstyledButton>
    );
  });
  return (
    <Header height={70} className={classes.root}>
      <Container>
        <div className={classes.inner} style={{ display: "flex" }}>
          <img
            className={classes.logoImage}
            src={NewLogoImage}
            alt="LogoImage"
          />
          <Group spacing={5} className={classes.links}>
            {items}
          </Group>
          <Burger
            opened={opened}
            onClick={() => toggleOpened()}
            className={classes.burger}
            size="sm"
          />
          <Transition
            transition="pop-top-right"
            duration={200}
            mounted={opened}
          >
            {(styles) => (
              <Paper className={classes.dropdown} withBorder style={styles}>
                {items}
              </Paper>
            )}
          </Transition>
        </div>
      </Container>
    </Header>
  );
};
